import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["policy", "prerequisites", "memberList"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.policyTargets.find((radio) => radio.checked)
    this.prerequisitesTarget.hidden = selected?.value !== "restricted"
    if (this.hasMemberListTarget) {
      this.memberListTarget.hidden = selected?.value !== "member_list"
    }
  }
}
